export { default, getServerSideProps } from '@/common/pages/home/knowledgeBase/knowledgeBase';
